export default __webpack_public_path__ + "static/media/Greataxe of the Red Tide.59952cdb.jpg";